/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskResultsUnmask } from "../funcs/riskResultsUnmask.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskUnmaskResultResult } from "../models/components/riskunmaskresultresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UnmaskRiskResultRequest,
  UnmaskRiskResultSecurity,
} from "../models/operations/unmaskriskresult.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskUnmaskResultMutationVariables = {
  request: UnmaskRiskResultRequest;
  security?: UnmaskRiskResultSecurity | undefined;
  options?: RequestOptions;
};

export type RiskUnmaskResultMutationData = RiskUnmaskResultResult;

export type RiskUnmaskResultMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * unmaskRiskResult risk
 *
 * @remarks
 * Return the plaintext match for a single risk result on demand. Every finding requires chat:read for its attributed chat. MCP findings with an empty or invalid chat ID require an unrestricted chat:read grant and use encrypted stored evidence. Every successful reveal is audited.
 */
export function useRiskUnmaskResultMutation(
  options?: MutationHookOptions<
    RiskUnmaskResultMutationData,
    RiskUnmaskResultMutationError,
    RiskUnmaskResultMutationVariables
  >,
): UseMutationResult<
  RiskUnmaskResultMutationData,
  RiskUnmaskResultMutationError,
  RiskUnmaskResultMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskUnmaskResultMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskUnmaskResult(): MutationKey {
  return ["@gram/client", "results", "unmask"];
}

export function buildRiskUnmaskResultMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskUnmaskResultMutationVariables,
  ) => Promise<RiskUnmaskResultMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskUnmaskResult(),
    mutationFn: function riskUnmaskResultMutationFn({
      request,
      security,
      options,
    }): Promise<RiskUnmaskResultMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskResultsUnmask(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
